const DOCS_CONSTANTS = {
  TITLES: {
    OVERVIEW: "Overview",
    GET_STARTED_WITH_OTPLESS: "Get Started with OTPless",
    LOGIN_WITH_WHATSAPP: "Login With Whatsapp",
    BACKEND_APIS: "Backend APIs",
    SDK_AND_API_REFERENCE: "Frontend SDKs",
    SDK_HOME: {
      NEW_TO_OTPLESS: "New to OTPless?",
    },
    API_REFERENCE: {
      TITLE: "API reference",
    },
    REST_API: {
      TITLE: "Rest API",
      INITIATE_LOGIN: "Get URL",
      GET_USER_API: "Verify User",
      POSTMAN_COLLECTION: "Postman Collection",
    },
    ANDROID: {
      TITLE: "Android",
      APP_SETUP: "App Setup",
      INSTALLATION: "Installation",
      USAGE: "Usage",
    },
    IOS: {
      TITLE: "iOS",
      APP_SETUP: "App Setup ",
      INSTALLATION: "Installation ",
      USAGE: "Usage ",
      HOW_IT_WORKS: "How it works? ",
    },
    JAVASCRIPT: {
      TITLE: "Javascript",
      INSTALL: "Install",
      INITIALISE: "Initialization",
      METHOD: "Methods",
    },
    FLUTTER: {
      TITLE: "Flutter",
      INSTALL: "Install",
      IMPORT: "Import",
      INSTANCE: "Create Instance",
      METHOD: "Functions",
      NATIVE_PART: "Native Part",
    },
  },
  SDK_ROUTE_PARAM: {
    REST_API: "rest_api",
    ANDROID: "android",
    IOS: "ios",
    JAVASCRIPT: "javascript",
    FLUTTER: "flutter",
  },
  ENDPOINT: {
    REST_API: {
      INITIATE_LOGIN: {
        TYPE: "POST",
        URL: "https://api.otpless.app/v1/client/user/session/initiate",
      },
      GET_USER_DATA: {
        TYPE: "POST",
        URL: "https://api.otpless.app/v1/client/user/session/userdata",
      },
      POSTMAN: {
        URL: "https://www.postman.com/otpless/workspace/d10e1614-c6d4-448e-a622-399a331e977f/colle[…]c5c-857c-4796-a168-621d1d79f44f?action=share&creator=23230791",
      },
    },
    ANDROID: {
      SDK_LINK:
        "https://otpless-cdn.s3.ap-south-1.amazonaws.com/OTPless-Android-SDK.aar",
    },
    IOS: {
      SDK_LINK:
        "https://otpless-cdn.s3.ap-south-1.amazonaws.com/OTPless-iOS-SDK.zip",
    },
  },
};

export default DOCS_CONSTANTS;
